import React from "react";

const HeaderSortSpan = ({
  className,
  keyName,
  title,
  onSortChange,
  sortConfig,
}) => {
  const getDirectionFor = (name) => {
    if (!sortConfig.key) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  return (
    <button
      aria-pressed={sortConfig.key === keyName}
      className={`${className} inventory-sort-button`}
      type="button"
      onClick={() => onSortChange(keyName)}
    >
      {title}{" "}
      {getDirectionFor(keyName) === "ascending"
        ? "↑"
        : getDirectionFor(keyName) === "descending"
        ? "↓"
        : ""}
    </button>
  );
};
export default HeaderSortSpan;
